import { Box, Grid } from '@material-ui/core';
import { IProjectClient } from 'app/models/entities/IProjectClient';
import { IProject } from 'app/models/responses/IProject';
import { Details, Metrics } from './components';

interface IProps {
  project: IProject;
  projectClient: IProjectClient;
}

const ProjectOverview = ({ project, projectClient }: IProps) => {
  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Details project={project} projectClient={projectClient} />
        </Grid>
        <Grid item xs={12} md={6}>
          <Metrics project={project} projectClient={projectClient} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default ProjectOverview;
